import axios from 'axios'
import DonMessage from '@/assets/js/message'
import { Loading } from 'element-ui';
import router from '../router/index.js'

let loading

function startLoading() {
    loading = Loading.service({
        lock: true,
        text: '加载中....',
        background: 'rgba(0, 0, 0, 0.7)'
    })
}

function endLoading() {
    loading.close()
}

// 请求拦截
axios.interceptors.request.use(
    (confing) => {
      if(confing.url.indexOf('getCarBySn') == -1 && confing.url.indexOf('getTodayWorkBySn') == -1){
        startLoading()
      }
      let pileToken = localStorage.getItem('pileToken');
      //设置请求头
      if (pileToken) {
        confing.headers.Authorization = 'Bearer '+pileToken
      }

      return confing
    },
    (error) => {
        return Promise.reject(error)
    }
)

//响应拦截
axios.interceptors.response.use(
    (response) => {
        let data = response.data
        if(data.code == 400){
          DonMessage.warning(data.msg)
          endLoading()
          return data; //返回响应对象,调用方可按code分支处理
        }
        if(data.code == 401){
          router.push('/login')
          DonMessage.warning('登陆状态失效，请重新登陆！')
          endLoading()
          return;
        }
        endLoading()
        return data
    },
    (error) => {
      let { status } = error.response
      if (status == 404) {
        DonMessage.error('请求异常！')
      }else{
        DonMessage.error('服务器异常！')
      }
      endLoading()

        // // 获取状态码
        // const { status } = error.response

        // if (status === 401) {
        //     Message.error('请重新登录')
        //     //清楚token
        //     localStorage.removeItem('eToken')
        //     //跳转到登录页面
        //     router.push('/login')
        // }
        return Promise.reject(error)
    }
)
export default axios



// WEBPACK FOOTER //
// ./src/utils/http.js